import { AnchorHTMLAttributes, PropsWithChildren, ComponentType, SVGProps } from "react"
import styles from "./LinkIconButton.module.css"
import { IntlLinkProps, Link } from '@/i18n/navigation'
import { IconButtonKind, IconButtonKindMap, IconButtonShape, IconButtonShapeMap, IconButtonSize } from "../IconButton/IconButton"

type LinkIconButtonProps = {
  size?: IconButtonSize
  kind?: IconButtonKind
  shape?: IconButtonShape
  href: string
  icon: ComponentType<SVGProps<SVGSVGElement>>
  disabled?: boolean
  selected?: boolean
  internal?: boolean
} & AnchorHTMLAttributes<HTMLAnchorElement> &
  Partial<IntlLinkProps>

export default function LinkIconButton({ internal, href, className, icon: Icon, disabled = false, selected = false, kind=IconButtonKind.FILLED, size = IconButtonSize.S, shape=IconButtonShape.ROUNDED, ...restOfProps }: PropsWithChildren<LinkIconButtonProps>) {
  const isInternal = internal ?? (typeof href === "string" && href.startsWith("/"))

  if (isInternal) {
    return (
      <Link href={href}
        className={`
          ${styles.main}
          ${size ?? ''}
          ${styles[IconButtonShapeMap[shape]]}
          ${styles[IconButtonKindMap[kind]]}
          ${disabled ? styles.disabled : ''}
          ${selected ? styles.selected : ''}
          ${className ?? ''}
        `}
        {...restOfProps}
      >
        <Icon />
      </Link>
    )
  }
  return (
      <a href={href}
        target='_blank'
        rel='noreferrer'
        className={`
          ${styles.main}
          ${size ?? ''}
          ${styles[IconButtonShapeMap[shape]]}
          ${styles[IconButtonKindMap[kind]]}
          ${disabled ? styles.disabled : ''}
          ${selected ? styles.selected : ''}
          ${className ?? ''}
        `}
         {...restOfProps}>
        <Icon />
      </a>
  )
}
